// extracted by mini-css-extract-plugin
module.exports = {"clickable":"styles_clickable__14TMm","large":"styles_large__2N72D"};